<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="35%">
            <el-form ref="form" :model="form" :rules="rules" label-width="90px">
                <el-form-item prop="projectType" label="项目">
                    <el-select v-model="form.projectType" placeholder="请选择项目" style="width:100%;">
                        <el-option
                            v-for="item in projectTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="remark" label="说明">
                    <el-input
                        type="textarea"
                        v-model="form.remark"
                        :rows="4"
                        maxlength="100"
                        show-word-limit
                        placeholder="请输入说明，最多100字">
                    </el-input>
                </el-form-item>
                <el-form-item prop="privilege" label="特权">
                    <el-input
                        type="textarea"
                        v-model="form.privilege"
                        :rows="4"
                        maxlength="100"
                        show-word-limit
                        placeholder="请输入特权，最多100字">
                    </el-input>
                </el-form-item>
                <el-form-item prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" type="number" style="width:100%;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import http from '../../../../common/http';

export default {
    data(){
        return{
            visible: false,
            form: {
                projectType: '',
                remark: '',
                privilege: '',
                orderNum: 1
            },
            projectTypeOptions: [
                { value: '1', label: 'AI智伴' },
                { value: '2', label: '校园通话' },
                { value: '3', label: '语音留言' },
                { value: '4', label: '智能校徽' }
            ],
            rules: {
                projectType: [
                    { required: true, message: '请选择项目', trigger: 'change' }
                ],
                remark: [
                    { required: true, message: '请输入说明', trigger: 'blur' },
                    { max: 100, message: '说明最多100字', trigger: 'blur' }
                ],
                privilege: [
                    { required: true, message: '请输入特权', trigger: 'blur' },
                    { max: 100, message: '特权最多100字', trigger: 'blur' }
                ],
                orderNum: [
                    { required: true, message: '请输入排序号', trigger: 'blur' }
                ]
            }
        };
    },
    methods:{
        init(){
            this.visible = true;
            if (this.$refs['form']) {
                this.$refs['form'].resetFields();
            }
            this.form.projectType = '';
            this.form.remark = '';
            this.form.privilege = '';
            this.form.orderNum = 1;
        },
        dialogClose(done){
            done();
            this.$reload;
        },
        save(){
            this.$refs['form'].validate((valid) => {
                if(valid){
                    let url = this.memberPrivilegeSaveUrl;
                    let data = {
                        projectType: this.form.projectType,
                        remark: this.form.remark,
                        privilege: this.form.privilege,
                        orderNum: this.form.orderNum
                    };
                    this.apiPost(url, data).then((res) => {
                        if(res.status === 200){
                            this.$commonFn.showTip(res.message,1);
                            this.visible = false;
                            this.$parent.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    }, (err) => {
                        console.log(err);
                    });
                }
            });
        }
    },
    mixins: [http]
};
</script>



// WEBPACK FOOTER //
// src/components/page/member/privilege/Add.vue